import { render, staticRenderFns } from "./StepPackage.vue?vue&type=template&id=004769bc&scoped=true"
import script from "./StepPackage.vue?vue&type=script&lang=ts"
export * from "./StepPackage.vue?vue&type=script&lang=ts"
import style0 from "./StepPackage.vue?vue&type=style&index=0&id=004769bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004769bc",
  null
  
)

export default component.exports